import React from "react"

const FormSubmissionAuditTrailContext = React.createContext(null)

export default FormSubmissionAuditTrailContext
